import {addToCart} from "./mini-cart";

const productRatings = document.querySelectorAll(".product-card__rating");

productRatings.forEach(productRating => {
    const badge = productRating.querySelector(".stamped-badge-caption");
    const finalRatingElement = productRating.querySelector(".product-card__rating-final");
    const eggoBadge = productRating.querySelector("#eggo-badge");

    if (!badge) {
        productRating.remove();
        return;
    }

    const rating = badge.dataset.rating;
    let numberOfReviews = badge.dataset.reviews;

    if(eggoBadge){
        const reviewCount = eggoBadge.dataset.reviewCount;
        if(reviewCount){
            numberOfReviews = parseInt(reviewCount);
        }
    }
    const countString = numberOfReviews > 4 ? stringReviews["more"] : stringReviews[numberOfReviews];
    finalRatingElement.innerHTML = `${rating}/5.0 <span class="product-card__rating-final-count">${numberOfReviews} ${countString}</span>`;
});

document.addEventListener('DOMContentLoaded', function () {
    registerAddToCartCards();
    registerProductCardVariantColors();
});

function registerAddToCartCards() {
    const buttons = document.querySelectorAll("#MainContent .is-add-to-cart:not(.eggo-button--buy)");
    if (!buttons) return;
    buttons.forEach((button) => button.addEventListener("click", buttonAddToCart));
}

export function buttonAddToCart(e) {
    e.preventDefault();
    const variationId = this.dataset.variation;
    if (!variationId) {

        const variationMessageElementClass = `.${this.dataset.buttonAttribute}`;
        const variationMessageElement = this.parentNode.querySelector(variationMessageElementClass);
        variationMessageElement.classList.add("visible");
        return;
    }

    const item = {
        id: variationId,
        quantity: 1
    };
    /** Marks gifts added through the cart gift offer so they can be removed again if the threshold is no longer met. */
    const giftCard = this.closest(".cart-drawer__gift");
    if (giftCard) item.properties = {_eggo_gift: giftCard.dataset.price};
    addToCart([item]);

}

export function registerVariantColorsCard(className, element = document) {

    const variantColors = element.querySelectorAll(className)
    variantColors.forEach(variantButton => {
        variantButton.addEventListener("click", function (e) {
            e.preventDefault();
            let fakeButtonElement = null;
            const cardImageClass = variantButton.dataset.imageElement;
            const imageElement = element.querySelector(cardImageClass);
            const buttonElement = element.querySelector(variantButton.dataset.button);
            if (buttonElement) fakeButtonElement = buttonElement.parentElement.querySelector("div.eggo-button");
            const variationId = variantButton.dataset.variationId;
            const messageItemClass = variantButton.dataset.message;
            const messageItem = element.querySelector(messageItemClass);
            const productVariantColors = variantButton.parentNode.querySelectorAll(".product-card__variant-color");

            if (messageItem) {
                messageItem.classList.remove("visible");
                if (imageElement) {
                    imageElement.src = variantButton.dataset.imageUrl;
                }
                buttonElement.dataset.variation = variationId;
            }
            if(productVariantColors) {
                productVariantColors.forEach(variantButton => variantButton.classList.remove("selected"));
            }
            variantButton.classList.add("selected");
            if (variantButton.classList.contains("notavailable")) {
                if (buttonElement) buttonElement.classList.add("hide-this");
                if (fakeButtonElement) fakeButtonElement.classList.remove("hide-this");
            } else {
                if (buttonElement) buttonElement.classList.remove("hide-this");
                if (fakeButtonElement) fakeButtonElement.classList.add("hide-this");
            }
        });
    })
}

const registerProductCardVariantColors = () => {
    registerVariantColorsCard("#MainContent .product-card__image-selector .product-card__variant-color");
}

export const registerProductCardCartColors = (element) => {
    registerVariantColorsCard(".product-card__variant-color", element);
}
